import { jwtDecode } from "jwt-decode";

export const isJWTExpired = (sessionJwt: string) => {
  const jwtPayload = jwtDecode(sessionJwt);
  if (!jwtPayload.exp) {
    throw new Error("No expiration found in JWT");
  }
  return new Date(jwtPayload.exp * 1000) < new Date();
};
